import React, { Component } from 'react';

export class SonificationSelection extends Component {

    render() {

        return(
            <p>
                <label>Select date</label>
                <select onChange={this.props.onChange}>
                    <option value="melb20201205">5th December 2020</option>
                    <option value="melb20201204">4th December 2020</option>
                    <option value="melb20201105">5th November 2020</option>
                    <option value="melb20210205">5th February 2021</option>
                </select>
            </p>
        )
    }


}